import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import { api } from "api";
import { toaster } from "utils/toaster";
import ApplicationYearSelector from "./ApplicationYearSelector";
import { useSupersetHandlers } from "./useSupersetHandlers";

const ApplicationSelectorWrapper = styled("div")({
  paddingTop: "1rem",
  paddingLeft: "1rem",
  width: "300px",
  display: "flex",
  alignItems: "center",
  gap: "1rem",
});

const IFrameHolder = styled("div")({
  width: "100%",
  height: "100%",
  "& iframe[title=supersetDashboard]": {
    width: "100%",
    height: "100%",
  },
});

const Report = ({ taxNumber, applicationYears = [], isShown }) => {
  const [supersetConfig, setSupersetConfig] = useState({
    token: "",
    dashboardId: "",
    supersetDomain: "https://superset.camvio.gr",
  });
  const [selectedYear, setSelectedYear] = useState(() => {
    const latestYear = applicationYears?.reduce(
      (a, b) => Math.max(a, b),
      -Infinity
    );

    return latestYear || 2024;
  });

  const { embedSupersetDashboard } = useSupersetHandlers();

  useEffect(() => {
    if (!taxNumber || !selectedYear) return;

    const fetchSuperset = async () => {
      try {
        const res = await api.superset.fetchConfig(taxNumber, selectedYear);
        setSupersetConfig((prev) => ({ ...prev, ...res.data }));
      } catch (error) {
        toaster.error({ message: "Error fetching superset config" });
      }
    };
    fetchSuperset();
  }, [taxNumber, selectedYear]);

  useEffect(() => {
    const showcaseIframe = () => {
      const container = document.getElementById("iframe-container");

      if (container) {
        embedSupersetDashboard({
          mountPointId: "iframe-container",
          id: supersetConfig.dashboardId,
          supersetDomain: supersetConfig.supersetDomain,
          token: supersetConfig.token,
        });
      }
    };
    const isConfigFetched = supersetConfig.token;

    if (isShown && isConfigFetched && embedSupersetDashboard) {
      setTimeout(() => {
        showcaseIframe();
      }, 300);
    }
  }, [isShown, supersetConfig, embedSupersetDashboard]);

  return (
    <>
      <ApplicationSelectorWrapper>
        <ApplicationYearSelector
          year={selectedYear}
          applicationYears={applicationYears}
          onChange={setSelectedYear}
        />
      </ApplicationSelectorWrapper>
      <IFrameHolder id="iframe-container"></IFrameHolder>
    </>
  );
};

export default Report;
